import React, { Component } from 'react';
import PDFObject from 'pdfobject';
import PropTypes from 'prop-types';
class PdfViewer extends Component {
  constructor() {
    super();
    this.state = {
      containerPdfId: null
    }
  }
  componentDidMount() {
    const { containerId } = this.props;
    if (this.props.sectionData) {
      this.setState({
        containerPdfId: containerId + '-' + this.props.sectionData.sectionTemplateId
      }, () => {
        PDFObject.embed(`${this.props.pdfUrl}`, `#${this.state.containerPdfId}`);
      })
    } else {
      this.setState({
        containerPdfId: containerId
      }, () => {
        PDFObject.embed(`${this.props.pdfUrl}`, `#${this.state.containerPdfId}`);
      })
    }

  }
  componentDidUpdate(prevProps) {
    const { containerId } = this.props;
    if (this.props.pdfUrl !== prevProps.pdfUrl) {
      if (this.props.sectionData && this.props.sectionData.sectionTemplateId) {
        this.setState({
          containerPdfId: containerId + '-' + this.props.sectionData.sectionTemplateId
        }, () => {
          PDFObject.embed(`${this.props.pdfUrl}`, `#${this.state.containerPdfId}`);
        })

      } else {
        this.setState({
          containerPdfId: containerId
        }, () => {
          PDFObject.embed(`${this.props.pdfUrl}`, `#${this.state.containerPdfId}`);
        })
      }
    }
  }
  render() {
    const { width, height } = this.props;
    return <div style={{ width, height }} id={this.state.containerPdfId} />;
  }
}

PdfViewer.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  containerId: PropTypes.string,
};

PdfViewer.defaultProps = {
  width: '100%',
  height: '520px',
  containerId: 'pdfViewer',
};

export default PdfViewer;
